import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { IHasChildren } from '@/lib/interface';

const CONSTS = {
  queryClient: new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: 'always',
        staleTime: 10 * 1000,
        retry: false
      }
    }
  })
};

const ReactQueryClientProvider = ({ children }: IHasChildren) => (
  <QueryClientProvider client={CONSTS.queryClient}>
    {children}
  </QueryClientProvider>
);

export default ReactQueryClientProvider;
